export const AFFORD_TOPIC_KEY = 'chromebot_listing_affordability_to_customer'
export const INVESTMENT_TOPIC_KEY = 'chromebot_listing_investment_to_customer'
export const PREQUAL_TOPIC_KEY = 'chromebot_listing_prequalification_to_sponsor'
export const CUSTOM_QUESTION_TOPIC_KEY = 'chromebot_listing_custom_to_customer'
